import { Pipe, PipeTransform } from '@angular/core';
import { EmailAuditEventType } from '@app-types/enums/email-audit-event-type';

@Pipe({
  name: 'emailAuditEventType',
  standalone: true,
})
export class EmailAuditEventTypePipe implements PipeTransform {
  transform(value: number): string {
    return 'emailAuditEventType' + EmailAuditEventType[value];
  }
}
